import { TypographyTooltip } from 'pages/Representatives/components/TypographyTooltip';
import { FileType } from 'shared/enums/FileType';

type EditProfileNoMediaTextProps = {
  type: FileType;
};

const EditProfileNoMediaText = ({ type }: EditProfileNoMediaTextProps) => {
  return (
    <div
      style={{
        height: 50,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
        marginTop: 20,
      }}
    >
      <TypographyTooltip noWrap={false} variant="h3">{`No ${type} Selected`}</TypographyTooltip>
      <TypographyTooltip
        noWrap={false}
        variant="h4"
      >{`You can upload new ${type.toLowerCase()}s by clicking the 'ADD ${type.toUpperCase()}' button.`}</TypographyTooltip>
    </div>
  );
};

export default EditProfileNoMediaText;
